import Glide from '@glidejs/glide';

export const B__BannerTestimonials = () => ({
    init: () => {
        new Glide('.b--banner-testimonials .glide').mount();
    }
});
